// src/redux/actions/siteActions.js
export const SET_UI_FEATURE = 'SET_UI_FEATURE';

export const setUifeature = (uifeature) => ({
  type: SET_UI_FEATURE,
  payload: uifeature,
});
